var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 121,
    viewBox: "0 0 93 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Silver Medal",
    filter: "url(#filter0_d_3684_50667)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M33.3789 65.293L44.0626 71.4612L22.3674 109.038L16.1404 95.1509L33.3789 65.293Z",
    fill: "#71D641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 9",
    d: "M33.3789 64.9492L22.6952 58.781L0.999935 96.3582L16.1404 94.8072L33.3789 64.9492Z",
    fill: "#2DA62B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M48.6211 64.9492L37.9374 71.1175L59.6326 108.695L65.8596 94.8072L48.6211 64.9492Z",
    fill: "#2DA62B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11",
    d: "M48.6211 65.293L59.3048 59.1247L81.0001 96.702L65.8596 95.1509L48.6211 65.293Z",
    fill: "#71D641"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 40.9832,
    cy: 39.4187,
    r: 37.282,
    fill: "#E3E3E3",
    stroke: "#404040"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 40.9832,
    cy: 39.4187,
    r: 28.7117,
    fill: "#595959"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50667",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 59,
    height: 59
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_2",
    cx: 42.5148,
    cy: 42.4836,
    r: 28.7785,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3_2",
    cx: 40.9816,
    cy: 39.4191,
    r: 28.7785,
    fill: "url(#paint0_linear_3684_50667)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.1394 19.3984L47.3473 31.8143L59.7632 33.3663L51.2376 42.9265L53.5553 56.646L41.1394 50.4381L28.7236 56.646L31.0619 42.9265L22.5156 33.3663L34.9315 31.8143L41.1394 19.3984Z",
    fill: "url(#paint1_linear_3684_50667)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50667",
    x: 0.216502,
    y: 0.853221,
    width: 92.536,
    height: 119.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50667",
    x1: 40.9816,
    y1: 10.6406,
    x2: 40.9816,
    y2: 68.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CA1A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50667",
    x1: 41.1394,
    y1: 19.3984,
    x2: 41.1394,
    y2: 56.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCompleted);
export default __webpack_public_path__ + "static/media/Project_Completed.a11eae5d64d9cc56ee55059271b0bfc2.svg";
export { ForwardRef as ReactComponent };